import { PartialType } from '../../../../utils';
import { CreateServiceCenterDto } from '../create/create-service-center.dto';
export class UpdateServiceCenterDto extends PartialType(CreateServiceCenterDto) {
}
